import { Component, OnInit, DoCheck } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { ViewChild, ElementRef } from '@angular/core';
import { TranslateService } from '@ngx-translate/core';
import { VgApiService } from '@videogular/ngx-videogular/core';
import { AnalyticEvent } from 'app/lib/analytic-event';
import { LogService } from 'app/lib/log.service';
import { SeriesService } from 'app/lib/series.service';
import { voice } from 'app/models/course';
import { UtilityService } from 'app/lib/utility.service';
import { Location } from '@angular/common';
import { User } from 'app/models/user';
import { UserService } from 'app/lib/user.service';
@Component({
    selector: 'app-series-voices-player',
    templateUrl: './series-voices-player.component.html',
    styleUrls: ['./series-voices-player.component.scss'],
})
export class SeriesVoicesPlayerComponent implements OnInit, DoCheck {
    loaded: boolean = false;
    voiceList: any = [];
    @ViewChild('audioPlayer') audioPlayer: ElementRef;
    voiceId: any;

    playing = false;
    voiceVolume = 50;
    voiceType: string = 'none';
    timer: any;
    lang: string = 'en';
    currentVoice: any = {};
    isPlaying: boolean = false;
    selectedStarIndex: number = 0;
    rating: number = 0;
    currentTime: any = 0;
    api: VgApiService;
    transcriptExpanded: boolean = false;
    user: User;
    isAudioLoaded: boolean = false;
    constructor(
        private translate: TranslateService,
        private log: LogService,
        private userService: UserService,
        private activatedRoute: ActivatedRoute,
        private seriesService: SeriesService,
        private utilityService: UtilityService,
        private location: Location,
        private router: Router
    ) {
        this.voiceType = this.activatedRoute.snapshot.paramMap.get('voiceType');
        this.voiceId = this.activatedRoute.snapshot.paramMap.get('voiceId');
    }

    ngOnInit() {
        this.lang = this.translate.currentLang;
        this.user = this.userService.getUser();
        this.getStories();
        this.setRating();
    }
    ngDoCheck() {
        this.lang = this.translate.currentLang;
    }
    get displayText() {
        return this.transcriptExpanded
            ? this.currentVoice['transcript_' + this.lang]
            : this.utilityService.truncateTextToTwoLines(
                  this.currentVoice['transcript_' + this.lang]
              );
    }

    getStories() {
        if (this.voiceType === 'stories') {
            this.seriesService.voiceStorySeries.subscribe((data: any) => {
                if (!data || data.status == 'error') return;
                if (data.status == 'success') {
                    this.setVoiceSeries(data.seriesList);
                }
            });
            this.seriesService.getVoiceStorySeries();
        } else {
            this.seriesService.voiceBurningQuestionSeries.subscribe(
                (data: any) => {
                    if (!data || data.status == 'error') return;
                    if (data.status == 'success') {
                        this.setVoiceSeries(data.seriesList);
                    }
                }
            );
            this.seriesService.getBurningQuestionsSeries();
        }
    }
    setVoiceSeries(series: any) {
        let voices = [];
        if (!Object.keys(series).length) {
            return;
        } else {
            this.loaded = true;
            voices = voice.initializeArray(series, this.voiceType);
        }
        this.getSelectedVoice(voices);
    }
    getSelectedVoice(voices) {
        this.currentVoice = voices?.find(item => item.id == this.voiceId);
        this.currentVoice?.courseProgress &&
            (this.currentVoice.courseProgress['Status'] = 'inprogress');
        this.voiceList = voices?.filter(
            voice => voice.category === this.currentVoice.category
        );
    }
    voiceVolumeChange(value: any) {
        this.voiceVolume = value;
        let newVol = 0.0;
        newVol = value / 100;
        this.api.volume = newVol;
    }
    onPlayerReady(api: VgApiService) {
        this.api = api;
        this.api.currentTime = +this.currentTime / 1000;

        this.api.getDefaultMedia().subscriptions.play.subscribe(() => {
            this.log.debug('Playing started.');
            this.isPlaying = true;
            this.timer && clearInterval(this.timer);
            this.timer = setInterval(() => {
                this.updateCurrentTimeProgress();
            }, 8000);
        });
        this.api.getDefaultMedia().subscriptions.playing.subscribe(() => {
            this.currentVoice?.courseProgress &&
                (this.currentVoice.courseProgress['Status'] = 'inprogress');
            this.log.debug('Playing.');
        });
        this.api
            .getDefaultMedia()
            .subscriptions.loadedData.subscribe(loadedData => {
                console.log('loadedData', loadedData);
                this.isAudioLoaded = true;
            });
        this.api
            .getDefaultMedia()
            .subscriptions.timeUpdate.subscribe(eeee => {});

        this.api.getDefaultMedia().subscriptions.pause.subscribe(() => {
            this.log.debug('Playing pause.');
            this.playing = false;
            clearInterval(this.timer);
        });

        this.api.getDefaultMedia().subscriptions.ended.subscribe(() => {
            if (this.api.fsAPI.isFullscreen && this.api.fsAPI.isAvailable) {
                this.api.fsAPI.toggleFullscreen();
            }
            this.log.debug('Playing end.');
            this.log.event(AnalyticEvent.commonEvents.voiceEnded, '', {
                [this.voiceType]: this.currentVoice.title_en,
            });
            clearInterval(this.timer);
            this.isPlaying = false;
            this.voiceEnded();
        });
    }
    voiceEnded() {
        this.playing = false;
        this.api.currentTime = 0;
        this.currentVoice.courseProgress['Status'] = 'completed';
        this.seriesService.updateAudioProgress(
            { current: 0, left: 0 },
            this.currentVoice,
            this.voiceType
        );
    }
    onPlay() {
        if (this.playing) {
            this.api.pause();
            this.log.event(AnalyticEvent.commonEvents.voicePaused, '', {
                [this.voiceType]: this.currentVoice.title_en,
            });
        } else {
            this.api.play();
            this.log.event(AnalyticEvent.commonEvents.voicePlayed, '', {
                [this.voiceType]: this.currentVoice.title_en,
            });
        }
        this.playing = !this.playing;
    }

    goBack() {
        this.location.back();
    }

    setRating() {
        this.rating = this.currentVoice.rating;
        this.selectedStarIndex = Math.floor(this.rating);
    }
    rateVoice(index: number) {
        this.selectedStarIndex = index;
        this.rating = index;
        if (this.currentVoice.rating == this.rating) {
            return;
        }
        if (this.playing) {
            this.onPlay();
        }
        this.seriesService.rateAudioSeries(
            this.rating,
            this.currentVoice,
            this.voiceType
        );
    }
    changeVoiceSeries(voiceData: voice) {
        if (voiceData.id != this.currentVoice.id) {
            this.updateCurrentTimeProgress();
            this.playing = false;
            this.isPlaying = false;
            this.isAudioLoaded = false;
            this.api.pause();
            this.timer && clearInterval(this.timer);
            this.api.currentTime = 0;
            this.router.navigate([
                '/app/series/voices/' + this.voiceType + '/' + voiceData.id,
            ]);
            this.voiceId = voiceData.id;
            this.currentVoice = voiceData;
            this.currentVoice?.courseProgress &&
                (this.currentVoice.courseProgress['Status'] = 'inprogress');
            this.setRating();
            this.audioPlayer.nativeElement.load();
            this.log.event(
                AnalyticEvent.internalPagesEvents.voicePlayerPage,
                '',
                {
                    [this.voiceType]: this.currentVoice.title_en,
                }
            );
        }
    }
    updateCurrentTimeProgress() {
        this.playing &&
            this.seriesService.updateAudioProgress(
                this.api.time,
                this.currentVoice,
                this.voiceType
            );
    }

    isExpanded = false;
    toggleText() {
        this.isExpanded = !this.isExpanded;
    }
}
